import type {
  BashFileTarget,
  StreamingBashWrite,
} from "./parseStreamingBashWrite";

export type FollowTargetInputs = {
  streamingFileWrite: StreamingBashWrite | null;
  streamingFileTarget: BashFileTarget | null;
  finalizedFileTarget: BashFileTarget | null;
  streamingAgentStep: string | undefined;
  aiPresentOnStepName: string | undefined;
  stepNames: ReadonlySet<string>;
};

export type FollowTarget = {
  step: string | undefined;
  filePath: string | undefined;
};

export function resolveFollowTarget({
  streamingFileWrite,
  streamingFileTarget,
  finalizedFileTarget,
  streamingAgentStep,
  aiPresentOnStepName,
  stepNames,
}: FollowTargetInputs): FollowTarget {
  const validate = (t: BashFileTarget | null) =>
    t && stepNames.has(t.stepDir) ? t : null;

  const fileTarget =
    validate(streamingFileWrite) ??
    validate(streamingFileTarget) ??
    validate(finalizedFileTarget);

  const candidate =
    fileTarget?.stepDir ?? streamingAgentStep ?? aiPresentOnStepName;
  const step = candidate && stepNames.has(candidate) ? candidate : undefined;

  return { step, filePath: fileTarget?.filePath };
}
